import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { APIService } from 'src/providers/apiservices/apiservices';
import { GlobalService } from 'src/providers/apiservices/globalservices';
import { ModalsProvider } from 'src/providers/modals/modals';

@Component({
  selector: 'app-modal-template',
  templateUrl: './modal-template.page.html',
  styleUrls: ['./modal-template.page.scss'],
})
export class ModalTemplatePage implements OnInit {
  @Input() item;
  @Input() mensagem;
  /** indica se foi uma acao do usuário ou um preview */
  @Input() acaousuario;



  showTextArea= false;
  showImageField= false;
  showBotao=false;
  
  modalAcessoItem;
  constructor(
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private router: Router,
    private modalsProvider:ModalsProvider,
    private globalService: GlobalService
  ) {
    /*
    <ion-select-option [value]=1>Imagem</ion-select-option>
    <ion-select-option [value]=2>Texto</ion-select-option>
    <ion-select-option [value]=3>Imagem e Texto</ion-select-option>
    */
    
  
  }

  ngOnInit() {
    console.log(this.item)
    if (this.item.tipo==1 || this.item.tipo==3){
      this.showImageField=true;
    }
    if (this.item.tipo==2 || this.item.tipo==3){
      this.showTextArea=true;
    }

    if (this.item.tipoLink){
      this.showBotao=true;

    }
    // if (this.mensagem){
    //   this.presentToast(this.mensagem,'success');
    // }
    if (this.acaousuario==true)
      this.enviaAcesso(false);

  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  /** MOSTRAR MENSAGEM DO COMPONENTE PAI */
  async presentToast(mensagem, cortoast) {
    //var cortoast;
    
    var lposicao = 'top';
    
    const toast = await this.toastCtrl.create({
      message: mensagem,
      duration: 20000,
      position: lposicao=='top'?'top':'bottom',
      color:cortoast,
      buttons: [
        {
          side: 'end',
          //icon: 'star',
          role: 'cancel',
          text: 'Fechar',
          handler: () => {

          }
        }
      ]
    });
    toast.present();
  }
  
  getRota(tela: string) {
    var canRead=false;
    switch (tela) {
      case 'Comunicação':
        // Verificar acesso
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS.Comunicação, cod_atividade: APIService.ATIVIDADES.LER_COMUNICADO});
        if (canRead)
          this.router.navigate(['/comunicacao']);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");

        break;
      case 'Autorização de Serviços':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS['Autorização de Serviço'], cod_atividade: APIService.ATIVIDADES.LISTAR_AUTORIZACOES_DE_SERVICO_LOJISTA});
        if (canRead)
         this.router.navigate(['/autorizacao']);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");

        break;
      case 'Informe de Vendas':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS['Informe de Vendas'], cod_atividade: APIService.ATIVIDADES.INFORMAR_VENDA});
        if (canRead)
         this.router.navigate(['/informe']);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");

        break;
      case 'Boletos e Cobrança':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS['Boletos e Avisos de Cobrança'], cod_atividade: APIService.ATIVIDADES.BOLETOS_E_AVISOS_DE_COBRANCA});
        if (canRead)
          this.router.navigate(['/cobranca', { tipo: 'boleto' }]);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");
        
        break;
      case 'Financeiro - Boletos':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS['Boletos e Avisos de Cobrança'], cod_atividade: APIService.ATIVIDADES.BOLETOS_E_AVISOS_DE_COBRANCA});
        if (canRead)
          this.router.navigate(['/cobranca', { tipo: 'boletos' }]);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");
        
        break;
      case 'Financeiro - Prestação de Contas':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS['Boletos e Avisos de Cobrança'], cod_atividade: APIService.ATIVIDADES.BOLETOS_E_AVISOS_DE_COBRANCA});
        if (canRead)
          this.router.navigate(['/cobranca', { tipo: 'prestacao' }]);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");
        
        break;
      case 'Conheça seus Clientes':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS.Multi, cod_atividade: APIService.ATIVIDADES.VER_DASHBOARD_MULTI});
        if (canRead){
          APIService.entradaDashboard = APIService.ENTRADA_BANNER;
          this.router.navigate(['/dashboard-multi']);
        }
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");
        
        break;
      case 'Biblioteca':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS.Arquivo, cod_atividade: APIService.ATIVIDADES.VER_ARQUIVOS});
        if (canRead)
          this.router.navigate(['/biblioteca']);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");
        
        break;
      case 'Formulário Benefícios':
        canRead = APIService.ValidarAcessoUsuario({id_modulo: APIService.MODULOS.Multi, cod_atividade: APIService.ATIVIDADES.VER_FORMULARIO_MULTI});
        if (canRead)
          this.router.navigate(['/formbeneficios/listagem']);
        else
          this.presentToast("Você não tem acesso para essa função. Fale com seu usuário master.","danger");
        
        break;
      default:

        window.open(tela, '_blank');
        canRead=true;
        break;
    }
     if (this.acaousuario==true && canRead==true)
      this.enviaAcesso(true);

    this.dismiss();
  }

  // Enviando dado que o usuário acessou o link
  async enviaAcesso(clicouNoLink) {
      //if (this.modalForm.valid) {
        this.modalsProvider.postAcesso(this.item.guid,this.modalAcessoItem?.guid, clicouNoLink)
        .then((response: any) => {
          
          if (response) {
            if (response.status_ret!="NOK"){
              this.modalAcessoItem=response;
            }
            else{
              this.globalService.publishToast({
              Mensagem: response.erro,
              Severidade: 2,
              Posicao: 'top',
            });
            }
           
          } else {
            this.globalService.publishToast({
              Mensagem: "Erro no serviço.",
              Severidade: 2,
              Posicao: 'top',
            });
          }
        })
        .catch((error: any) => {
          this.globalService.publishToast({
            Mensagem: error.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        })
        
    }
  

}
